import { getScoreOn20 } from '../../lib/utils/number';

import type { SummaryExercisesProgressionMap } from '~/types/quiz';

export const useExercisesSummaryProgressions = (
  progressionExercises: UseProgressionExercises,
  ids: string[]
) => {
  const allProgressions = computed(() => {
    return progressionExercises.progressions.value;
  });

  const progressions = computed(() => {
    if (!allProgressions.value) return [];
    return allProgressions.value.filter((progression) =>
      ids.includes(progression.contentId)
    );
  });

  const summaryExercisesProgressionMap = computed(() => {
    const temp: SummaryExercisesProgressionMap = {};
    progressions.value.forEach((pr) => {
      const data = pr.data as ExerciseDetailsProgression;
      const status = data.status;
      const score = data.points / data.maxPoints;
      temp[pr.contentId] = { score, status };
    });
    return temp;
  });

  const isCompleted = computed(() => {
    if (ids.length > progressions.value.length) return false;
    const notCompleted = progressions.value.find((pr) => {
      const data = pr.data as ExerciseDetailsProgression;
      return data.status !== 'done';
    });
    return !notCompleted;
  });

  const totalScore = computed(() => {
    if (!isCompleted) return -1;
    const score = Object.entries(summaryExercisesProgressionMap.value).reduce(
      (acc, [key, { score }]) => (acc = acc + score),
      0
    );
    return score / progressions.value.length;
  });

  const totalMarkOutOf20 = computed(() => getScoreOn20(totalScore.value));

  const completedExercisesCount = computed(() => {
    const count = progressions.value.reduce((acc, curr) => {
      const data = curr.data as ExerciseDetailsProgression;
      acc = data.status === 'done' ? acc + 1 : acc;
      return acc;
    }, 0);
    return count;
  });

  const onGoingExercisesCount = computed(() => {
    const count = progressions.value.reduce((acc, curr) => {
      const data = curr.data as ExerciseDetailsProgression;
      acc = data.status === 'onGoing' ? acc + 1 : acc;
      return acc;
    }, 0);
    return count;
  });

  const totalExercises = computed(() => ids.length);

  return {
    summaryExercisesProgressionMap,
    isCompleted,
    totalScore,
    totalMarkOutOf20,
    completedExercisesCount,
    onGoingExercisesCount,
    totalExercises,
  };
};
